<button mat-raised-button color="primary" (click)="getTariff()" [disabled]="disableEdit">
    {{ 'devices.data.buttons.request_now_value' | translate }}
</button>
